export default __webpack_public_path__ + "static/media/networks.62f3ede0.svg";